import React, { Component } from "react";
import ShareLinkStore from "./ShareLinkStore";
import Loader from "../../shared/Loader/Loader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import { observer } from "mobx-react";

const reactSwal = withReactContent(Swal);

class ShareLinkModalContent extends Component {
  constructor(props) {
    super(props);
    this.store = new ShareLinkStore();
    this.store.fetchContacts();
    this.send = this.send.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  render() {
    return (
      <div className="share-link-modal-content">
        {this.store.loadingContacts ? (
          <Loader size="button" />
        ) : (
          <div className="to-field">
            To:
            <Select
              placeholder="select recipient"
              className="Select"
              classNamePrefix="Select"
              options={this.store.contacts}
              onChange={this.store.changeContact}
              value={this.store.contact}
            />
          </div>
        )}
        <button
          type="button"
          className={["share-link", this.props.route.asRoute].join(" ")}
        >
          {this.props.patient.lastName}, {this.props.patient.firstName}
        </button>
        <textarea
          placeholder="Type Message"
          ref={(r) => (this.refMessage = r)}
        />
        <button onClick={this.send} className="btn">
          Send
        </button>
        <button onClick={this.cancel} className="btn secondary">
          Cancel
        </button>
      </div>
    );
  }

  send() {
    if (!this.store.contact || this.store.loadingContacts) {
      return;
    }
    const patientName = `${this.props.patient.lastName}, ${this.props.patient.firstName}`;
    const shareLink = this.store.translateRouteToShareLink(this.props.path);
    const message = `[${patientName}](${shareLink}) ${this.refMessage.value}`;
    this.store.postMessage(message).then(() => {
      this.props.messagingStore.showConversation(
        null,
        this.store.contact.value,
      );
      reactSwal.close();
    });
  }

  cancel() {
    reactSwal.close();
  }
}

export default observer(ShareLinkModalContent);

export function openShareLinkModal(options) {
  reactSwal.fire({
    title: "Share Patient Details",
    html: <ShareLinkModalContent {...options} />,
    showConfirmButton: false,
    customClass: "share-link-modal",
  });
}
